<script>
import InputTextEditor from '@/components(new)/UI/Forms/InputTextEditor/InputTextEditor.vue'
import DocumentUpload from '@/components(new)/UI/Forms/DocumentUpload/DocumentUpload.vue'
import VisualizarCadastro from '@/components(new)/UI/Modals/VisualizacaoCadastro/VisualizarCadastro.vue'
import AppButtonsCadastroSicarf from '@/components(new)/UI/Buttons/ButtonsCadastroSicarf/ButtonsCadastroSicarf.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import CertificacaoProcesso from './components/CertificacaoProcesso.vue'
import AppPdfViewer from '@/components/AppPDFViewer'
import { templateCertificadoParagrafoInicial, formatPrimeiroParagrafo } from '@/constants/certificacao'
import { mapActions } from 'vuex'

export default {
  components: {
    InputTextEditor,
    DocumentUpload,
    VisualizarCadastro,
    AppButtonsCadastroSicarf,
    CertificacaoProcesso,
    AppPdfViewer
  },

  mixins: [
    AppNotificacao
  ],

  async created () {
    try {
      const [infoAnalise, acoes] = await Promise.all([
        this.getInfoAnaliseCertificacaoById(this.$route.params.id),
        this.getAcoesTramitacaoById(this.$route.params.id)
      ])

      this.infoAnalise = infoAnalise
      this.acoes = acoes.map(acao => ({id: acao.id, nome: acao.descricao}))
      this.acoesDespacho = this.acoes.filter(acao =>
        !acao.nome.toLowerCase().includes('certificar') &&
        !acao.nome.toLowerCase().includes('certificação') &&
        !acao.nome.toLowerCase().includes('certificacao')
      )

      const acaoCertificacao = this.acoes.find(acao =>
        acao.nome.toLowerCase().includes('certificar') ||
        acao.nome.toLowerCase().includes('certificação') ||
        acao.nome.toLowerCase().includes('certificacao') ||
        acao.nome.toLowerCase().includes('emissão') ||
        acao.nome.toLowerCase().includes('emissao')
      )

      if (acaoCertificacao) {
        this.acaoCertificacao = acaoCertificacao.id
      } else {
        if (this.acoes.length > 0 && this.acoesDespacho.length < this.acoes.length) {
          const acaoRestante = this.acoes.find(acao =>
            !this.acoesDespacho.find(desp => desp.id === acao.id)
          )
          if (acaoRestante) {
            this.acaoCertificacao = acaoRestante.id
          }
        }
      }

      if (!this.infoAnalise.despacho) {
        this.infoAnalise.despacho = {
          texto: '',
          documentos: []
        }
      }
      this.dadosCertificacao = infoAnalise.certificado.informacoes
      this.textoCertificado = infoAnalise.certificado.texto
      this.paragrafoInicialCertificado = templateCertificadoParagrafoInicial.texto
    } catch (error) {
      console.error('Erro ao carregar dados:', error)
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        'Erro',
        'Erro ao carregar dados. Tente novamente.'
      )
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.showAvisoVoltar) {
      this.throwAvisoVoltar(() => next(), () => next(false))
    } else {
      next()
    }
  },
  data () {
    return {
      infoAnalise: {
        protocolo: null,
        numeroProcesso: null,
        despacho: null
      },
      acoes: [],
      acoesDespacho: [],
      acaoSelecionada: null,
      acaoCertificacao: null,
      showAvisoVoltar: true,

      tipoAcao: 'certificacao',
      dadosCertificacao: null,
      etapaAtual: 1,
      etapasCompletas: {
        1: false,
        2: false,
        3: false
      },
      textoCertificado: '',
      certificadoGerado: null,
      loadingCertificado: false,
      pdfBytes: null,
      paragrafoInicialCertificado: ''
    }
  },
  computed: {
    isPrimeiroPasso () {
      return true
    },
    isUltimoPasso () {
      return true
    },
    showButtonProximo () {
      return false
    },
    showButtonCancelar () {
      return true
    },
    showButtonSalvar () {
      return true
    },
    isDespacho () {
      return this.tipoAcao === 'despacho'
    },
    isCertificacao () {
      return this.tipoAcao === 'certificacao'
    }
  },
  methods: {
    ...mapActions({
      getInfoAnaliseById: 'processo/getInfoAnaliseById',
      getInfoAnaliseCertificacaoById: 'processo/getInfoAnaliseCertificacaoById',
      getAcoesTramitacaoById: 'processo/getAcoesTramitacaoById',
      salvarDespacho: 'despacho/salvar',
      finalizarDespacho: 'certificacao/finalizarDespacho',
      salvarCertificacaoStore: 'certificacao/salvarCertificacao',
      finalizarCertificacaoStore: 'certificacao/finalizarCertificacao',
      getDocumentoViewByIdProcesso: 'certificacao/getDocumentoViewByIdProcesso'
    }),
    alterarTipoAcao (tipo) {
      this.tipoAcao = tipo
      this.etapaAtual = 1
      this.certificadoGerado = null
    },
    async proximo () {
      if (this.etapaAtual < 3) {
        if (this.etapaAtual === 1) {
          const valid = await this.$refs.certificacaoProcesso.$refs.observer.validate()
          if (valid) {
            await this.salvarCertificacao()
            this.etapasCompletas[1] = true
            this.etapaAtual++
          } else {
            this.showNotificacao(
              this.$messages.TIPO_WARNING,
              this.$messages.TITULO_WARNING,
              'Preencha todos os campos obrigatórios antes de continuar.'
            )
          }
        } else if (this.etapaAtual === 2) {
          const valid = await this.$refs.certificacaoProcesso.$refs.observer.validate()
          if (valid) {
            await this.salvarCertificacao()
            this.etapasCompletas[2] = true
            this.etapaAtual++
            if (this.etapaAtual === 3) {
              this.gerarCertificado()
            }
          } else {
            this.showNotificacao(
              this.$messages.TIPO_WARNING,
              this.$messages.TITULO_WARNING,
              'Preencha todos os campos obrigatórios antes de continuar.'
            )
          }
        }
      }
    },

    voltar () {
      this.navigateBack()
    },

    voltarCertificacao () {
      if (this.isCertificacao && this.etapaAtual > 1) {
        this.etapaAtual--
      } else {
        this.navigateBack()
      }
    },
    cancelar () {
      this.navigateBack()
    },
    throwAvisoVoltar (callbackAccept, callbackReject) {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          if (callbackAccept) {
            this.showAvisoVoltar = false
            callbackAccept()
          }
        },
        () => {
          if (callbackReject) {
            callbackReject()
          }
        }, 'Sim', 'Não')
    },
    navigateBack () {
      if (this.$route.meta?.previousRoute?.meta?.routeGroup) {
        this.$router.push({ name: this.$route.meta?.previousRoute?.meta?.routeGroup })
        return
      }
      this.$router.back()
    },
    async salvar () {
      if (this.isDespacho) {
        this.infoAnalise.despacho = await this.salvarDespacho(this.infoAnalise.despacho)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Análise salva com sucesso.')
      }
    },
    async salvarCertificacao () {
      const valid = await this.$refs.certificacaoProcesso.$refs.observer.validate()
      if (valid) {
        try {
          const dadosParaEnviar = {
            certificado: {
              informacoes: this.dadosCertificacao,
              texto: formatPrimeiroParagrafo(this.paragrafoInicialCertificado, this.dadosCertificacao.caracteristicas) + this.textoCertificado
            }
          }
          await this.salvarCertificacaoStore({
            dados: dadosParaEnviar,
            despacho: this.infoAnalise.despacho
          })

          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.DADOS_SALVOS_SUCESSO)
        } catch (error) {
          console.error('Erro ao salvar certificação:', error)
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            'Erro',
            'Erro ao salvar certificação. Tente novamente.'
          )
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TIPO_WARNING,
          'Preencha todos os campos obrigatórios antes de salvar.'
        )
      }
    },
    async finalizar () {
      if (this.isDespacho) {
        await this.salvar()
        if (!await this.$refs.observer.validate()) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TIPO_WARNING,
            this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
          )
          return
        }

        await this.finalizarDespacho({ acao: this.acaoSelecionada, despacho: this.infoAnalise.despacho })

        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Análise finalizada com sucesso.')
        this.showAvisoVoltar = false
        this.navigateBack()
      }
    },
    async finalizarCertificacao () {
      if (this.etapaAtual === 3) {
        const valid = await this.$refs.certificacaoProcesso.$refs.observer.validate()
        if (valid) {
          try {
            const dadosParaEnviar = {
              certificado: {
                informacoes: this.dadosCertificacao,
                texto: formatPrimeiroParagrafo(this.paragrafoInicialCertificado, this.dadosCertificacao.caracteristicas) + this.textoCertificado
              }
            }

            const payloadFinalizar = {
              dados: dadosParaEnviar,
              despacho: this.infoAnalise.despacho,
              acao: this.acaoCertificacao
            }
            await this.finalizarCertificacaoStore(payloadFinalizar)

            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.CERTIFICADO_FINALIZADO_SUCESSO)
            this.showAvisoVoltar = false
            this.navigateBack()
          } catch (error) {
            console.error('Erro ao finalizar certificação:', error)
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              'Erro',
              'Erro ao finalizar certificação. Tente novamente.'
            )
          }
        } else {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TIPO_WARNING,
            'Preencha todos os campos obrigatórios antes de finalizar.'
          )
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TIPO_WARNING,
          'Complete todas as etapas antes de finalizar.'
        )
      }
    },
    uploadFile (file) {
      this.infoAnalise.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteDocumento(documento)
        },
        () => {}
      )
    },
    deleteDocumento (documento) {
      const compare = documento.id ? 'id' : 'key'
      const index = this.infoAnalise.despacho.documentos.indexOf(
        this.infoAnalise.despacho.documentos.findIndex(a => a[compare] === documento[compare])
      )
      this.infoAnalise.despacho.documentos.splice(index, 1)
    },
    receberDadosAlterados (novosDados) {
      this.dadosCertificacao = novosDados
    },

    receberTextoAlterado (novoTexto) {
      this.textoCertificado = novoTexto
    },

    async gerarCertificado () {
      this.loadingCertificado = true
      try {
        const response = await this.getDocumentoViewByIdProcesso(this.$route.params.id)
        if (!response) {
          throw new Error('Resposta inválida do servidor')
        }
        const documentoDto = response
        if (!documentoDto.bytes || typeof documentoDto.bytes !== 'string') {
          throw new Error('Bytes do documento não encontrados ou em formato inválido')
        }
        const pdfBytes = this.base64ToArrayBuffer(documentoDto.bytes)
        if (!pdfBytes || !(pdfBytes instanceof ArrayBuffer)) {
          throw new Error('Falha na conversão dos bytes para ArrayBuffer')
        }
        this.pdfBytes = pdfBytes
        const blob = new Blob([pdfBytes], { type: 'application/pdf' })
        this.certificadoGerado = URL.createObjectURL(blob)
        this.loadingCertificado = false
      } catch (error) {
        this.loadingCertificado = false
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          'Erro',
          'Erro ao gerar certificado. Tente novamente.'
        )
      }
    },

    base64ToArrayBuffer (base64) {
      try {
        const cleanBase64 = base64.replace(/[\n\r\s]/g, '')
        const binaryString = window.atob(cleanBase64)
        const bytes = new Uint8Array(binaryString.length)
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }
        return bytes.buffer
      } catch (error) {
        throw new Error(`Falha na conversão base64: ${error.message}`)
      }
    }
  }
}
</script>

<template>
  <div v-if="infoAnalise && infoAnalise.despacho && dadosCertificacao && infoAnalise.protocolo && infoAnalise.numeroProcesso" class="container">
    <div class="flex-row gap-2 mt-15px">
      <el-button
        @click="voltar"
        class="flex-center w-45px h-30px"
        type="primary"
      >
        <i class="fas fa-chevron-left"></i>
      </el-button>
      <span class="font-20px font-weight-600">Voltar</span>
    </div>
    <visualizar-cadastro
      v-if="infoAnalise && infoAnalise.protocolo && infoAnalise.numeroProcesso"
      :protocolo="infoAnalise.protocolo"
      cadastroContainerCustomClasses="card border-radius-4px bg-light-grey"
    />

    <div class="tipo-processo mt-3">
      <el-radio-group v-model="tipoAcao" @change="alterarTipoAcao">
        <el-radio label="despacho">Despacho</el-radio>
        <el-radio label="certificacao">Emitir Certificado</el-radio>
      </el-radio-group>
    </div>

    <div v-if="isDespacho">
      <el-card class="mt-3">
        <validation-observer ref="observer">
          <input-text-editor
            label="Despacho"
            v-model="infoAnalise.despacho.texto"
            validationRules="required"
          />
          <document-upload
            id="anexos-despacho"
            :files="infoAnalise.despacho.documentos"
            @uploadFile="uploadFile"
            @removeFile="removeFile"
          />
          <div class="mt-3 mb-1 flex-center">
            <el-radio-group v-if="acoesDespacho && acoesDespacho.length" v-model="acaoSelecionada">
              <el-radio
                v-for="acao in acoesDespacho"
                :key="acao.id"
                :label="acao.id"
              >
                {{ acao.nome }}
              </el-radio>
            </el-radio-group>
          </div>
        </validation-observer>
      </el-card>
    </div>

    <div v-else-if="isCertificacao">
      <certificacao-processo
        ref="certificacaoProcesso"
        :dadosCertificacao="dadosCertificacao"
        :textoCertificado="textoCertificado"
        :etapaAtual="etapaAtual"
        :etapasCompletas="etapasCompletas"
        :certificadoGerado="certificadoGerado"
        :loadingCertificado="loadingCertificado"
        @dadosAlterados="receberDadosAlterados"
        @textoAlterado="receberTextoAlterado"
      />
    </div>

    <app-buttons-cadastro-sicarf
      v-if="isDespacho"
      :isIntroPasso="false"
      :isPrimeiroPasso="isPrimeiroPasso"
      :isUltimoPasso="isUltimoPasso"
      :showButtonCancelar="showButtonCancelar"
      :showButtonProximo="showButtonProximo"
      :showButtonSalvar="showButtonSalvar"
      @salvar="salvar"
      @cancelar="cancelar"
      @finalizar="finalizar"
    />

    <app-buttons-cadastro-sicarf
      v-else-if="isCertificacao"
      :isIntroPasso="false"
      :isPrimeiroPasso="etapaAtual === 1"
      :isUltimoPasso="etapaAtual === 3"
      :showButtonCancelar="true"
      :showButtonSalvar="etapaAtual === 1 || etapaAtual === 2"
      @salvar="salvarCertificacao"
      @cancelar="cancelar"
      @voltar="voltarCertificacao"
      @proximo="proximo"
      @finalizar="finalizarCertificacao"
    />
  </div>
</template>

<style lang="scss" scoped>
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/analise/certificacao/emissao-certificado/emissao-certificado.vue